import { useState, useEffect } from 'react';

export const useAddRegister = (open: boolean, error: boolean, tabActive: string, update: any) => {
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [form, setForm ] = useState({
		entity_uuid: '',
		channel: '',
		operation: ''
	})

	const onHandleChange = (field, e) => {
		let f = form
		if(field !== 'expired_date'){
			f[field] = e.target.value
		} else {
			f[field] = new Date(e.target.value).toJSON()
		}
		setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
	}

	const validateForm = (f) => {
        if (f['entity_uuid'] && f['channel'] && f['operation'] && f['type']) {
          setIsValidForm(false);
        } else {
          setIsValidForm(true);
        }
    };

	useEffect(() => {
		if(open && !error && !update){
			let resetFrom = {
				entity_uuid: '',
				channel: '',
				operation: '',
			}
			if(tabActive !== 'accumulator'){
				resetFrom['type'] = tabActive
			}
			setForm(resetFrom)
		}
		if(open && !error && update){
			setForm(update)
		}
    }, [open, error, tabActive, update])

    return { form, isValidForm, onHandleChange }
};
